import React from 'react'
import Banner from "./banner/Banner";
import Who_We_Are from './who_we_are/Who_We_Are';
import What_We_Do from './what_we_do/What_We_Do';
import How_It_Work from './how_it_work/How_It_Work';
import Why_Choose_Us from './why_choose_us/Why_Choose_Us';
import Banner_2 from '../contact-us/banner_2/Banner_2';





const About_us = () => {
  return (
    <>
    <Banner/>
    <Who_We_Are/>
    <What_We_Do/>
    <How_It_Work/>
    <Why_Choose_Us/>
    <Banner_2/>
 
    
    </>
  )
}

export default About_us
